import { createChat, fetchChatList, fetchChatMessages, sendMessage } from '@/services/chats'
import { cloneDeep } from 'lodash'
import {
  ChatsActions,
  ChatsFetchChatPayload,
  ChatsGetSocketMessageHandlerPayload,
  ChatsSendMessagePayload,
  SocketMessageHandler,
} from './types'

const actions: ChatsActions = {
  async fetchClientChat({ commit, state }, { clientId }: ChatsFetchChatPayload): Promise<void> {
    commit('setChats', { ...state.chats, [clientId]: await fetchChatList({ clientId }) })

    const clientChats = state.chats[clientId]

    if (clientChats.length) {
      const messages = { ...state.messages }

      messages[clientId] = await fetchChatMessages({
        chatId: clientChats[0].id,
        limit: 10,
        offset: 0,
      })

      commit('setMessages', messages)
    }
  },
  async paginateChatMessages({ commit, state }, { clientId }): Promise<void> {
    const clientChats = state.chats[clientId]
    const messages = { ...state.messages[clientId] }

    if (!clientChats?.length || !messages || messages.messages.length >= messages.total) {
      return
    }

    const response = await fetchChatMessages({
      chatId: clientChats[0].id,
      limit: 10,
      offset: messages.messages.length,
    })

    messages.messages = [...response.messages, ...messages.messages]

    commit('setMessages', { ...state.messages, [clientId]: messages })
  },
  async getSocketMessageHandler(
    _,
    { clientId }: ChatsGetSocketMessageHandlerPayload
  ): Promise<SocketMessageHandler> {
    return (message) => {
      console.log(`GOT_MESSAGE::${clientId}::`, { ...message })
    }
  },
  async sendMessage(
    { commit, state },
    { clientId, message }: ChatsSendMessagePayload
  ): Promise<void> {
    const { chats, messages } = cloneDeep(state)

    if (chats[clientId] === undefined) {
      chats[clientId] = await fetchChatList({ clientId })
    }

    if (!chats[clientId].length) {
      chats[clientId].push(await createChat({ clientId }))

      messages[clientId] = await fetchChatMessages({
        chatId: chats[clientId][0].id,
        limit: 10,
        offset: 0,
      })

      commit('setMessages', messages)
    }

    commit('setChats', chats)

    const newMessage = await sendMessage({
      clientId,
      chatId: chats[clientId][0].id,
      text: message,
    })

    messages[clientId].messages.push(newMessage)
    messages[clientId].total += 1

    commit('setMessages', messages)
  },
}

export default actions
